import React from 'react'
import { Paper, useMediaQuery, useTheme } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline'
import styled from 'styled-components'

import { DIE_TYPES, ICON_BACKGROUNDS } from '../../constants'

const StyledPaper = styled(Paper)`
  display: flex; 
  justify-content: space-between;
  align-items: center;

  /* Fit 4 across on iPhone 6/7/8 */
  padding: ${props => props.$isSmall ? 2 : 4}px;
  margin: ${props => props.$isSmall ? 2 : 4}px;
`

const DieButton = styled.button`
  display: flex;
  align-items: center;
  appearance: none;
  border: 0;
  /* Remove user-agent background on mobile devices */
  background-color: transparent;
  width: 20px;
  height: 20px;
  margin: 0;
  padding: 0;
  cursor: pointer;
  touch-action: manipulation;

  svg {
    transition: color 0.2s;
  }

  &[disabled] {
    cursor: not-allowed;
  }

  &:focus {
    outline: 0;
  }

  ${props => props.isDarkMode && 'color: rgba(255, 255, 255, 0.5)'};

  &:hover {
    svg {
      color: ${props => props.isDarkMode ? 'white' : 'black'};
    }
  }
`

export const DieWrapper = ({ children, className, disabled, fill, isDarkMode, isSmall, onDieButtonClick }) => {
  return (
    <StyledPaper $isSmall={isSmall} elevation={0} variant='outlined' css={`
      opacity: ${disabled ? 0.5 : 1};
    `}>
      <div>
        <DieButton isDarkMode={isDarkMode} disabled={disabled} type='text' onClick={onDieButtonClick.bind(this, 1)}>
          <AddCircleOutlineIcon color={isDarkMode ? 'inherit' : 'primary'} />
        </DieButton>
        <DieButton isDarkMode={isDarkMode} disabled={disabled} type='text' css={`margin-top: 4px;`} onClick={onDieButtonClick.bind(this, -1)}>
          <RemoveCircleOutlineIcon color={isDarkMode ? 'inherit' : 'primary'} />
        </DieButton>
      </div>
      <div className={className} css={`
        margin-left: 8px;
        height: 50px;
        width: 50px;

        display: flex;
        justify-content: center;
        align-items: center;
        #fill {
          fill: ${fill};
        }
      `}>
        {children}
      </div>
    </StyledPaper>
  )
}

const Die = ({ disabled, amount = 0, isDarkMode, onDieChange, type }) => {
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'))

  const onClick = (value) => {
    const newAmount = Math.max(0, amount + value)
    onDieChange(newAmount)
  }

  const backgroundInfo = ICON_BACKGROUNDS[type]
  const Component = backgroundInfo.component
  const isSmallComponent = [DIE_TYPES.boost, DIE_TYPES.setback].includes(type)

  return (
    <DieWrapper
      disabled={disabled}
      fill={backgroundInfo.fill}
      isSmall={isSmall}
      isDarkMode={isDarkMode}
      onDieButtonClick={onClick}
    >
      <Component height={isSmallComponent ? 45 : 50} width={isSmallComponent ? 45 : 50} />
      <div css={`position: absolute; font-weight: bold; color: ${backgroundInfo.textColor};`}>
        {amount}
      </div>
    </DieWrapper>
  )
}

export default Die
